import { BoomGateAlertIcon } from './BoomGateAlertIcon';

/**
 * author: Michael Richins
 * id 2C3B8F49-7A38-49EE-8288-FDA6AC188727
 * name boom-gate-alert
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-alert.svg
 * tags
 * - Alert / Error 
 * - Transportation + Road 
 */
export const BoomArmAlertIcon = BoomGateAlertIcon;
export default BoomArmAlertIcon